class WIcartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.closeCart.bind(this));
    this.addEventListener("click", this.cartBgclick.bind(this));
    document.addEventListener("openCart", this.openCart.bind(this));
  }
  connectedCallback() {
    this.clickOncart();
  }

  clickOncart() {
    document.querySelector(".WI_cart-link").addEventListener("click", (e) => {
      e.preventDefault();
      this.openCart();
    });
    document.addEventListener("opencart", () => {
      this.openCart();
      let loadingCartBlock = document.querySelector(".WI_loadingCartItemBlock");
      let emptyCart = document.querySelector(".WI_cartDrawerin_cart_empty");
      if (loadingCartBlock != null) {
        loadingCartBlock.style.display = "block";
      }
      if (emptyCart != null) {
        emptyCart.style.display = "none";
      }
    });
  }
  openCart() {
    let cartDrawer = this.querySelector(".WI_cartDrawerin");
    let cartDrawerUpsell = this.querySelector(".WI_cartDrawerin_upsell");
    this.style.display = "flex";
    setTimeout(() => {
      this.style.backgroundColor = "rgba(0,0,0,0.5)";
      cartDrawer.style.transform = "translateX(0)";
      setTimeout(() => {
        cartDrawerUpsell.classList.add("WI_cartDrawerin_upsell_active");
      }, 200);
    }, 10);
  }
  closeCart(event) {
    if (event.target.matches(".WI_cartDrawerCls")) {
      let cartDrawer = this.querySelector(".WI_cartDrawerin");
      let cartDrawerUpsell = this.querySelector(".WI_cartDrawerin_upsell");
      cartDrawerUpsell.classList.remove("WI_cartDrawerin_upsell_active");
      setTimeout(() => {
        this.style.backgroundColor = "rgba(0,0,0,0)";
        cartDrawer.style.transform = "translateX(100%)";
        setTimeout(() => {
          this.style.display = "none";
        }, 310);
      }, 10);
    }
  }
  cartBgclick(event) {
    if (event.target.matches("wi-cartdrawer")) {
      let cartDrawer = this.querySelector(".WI_cartDrawerin");
      let cartDrawerUpsell = this.querySelector(".WI_cartDrawerin_upsell");
      cartDrawerUpsell.classList.remove("WI_cartDrawerin_upsell_active");
      setTimeout(() => {
        this.style.backgroundColor = "rgba(0,0,0,0)";
        cartDrawer.style.transform = "translateX(100%)";
        setTimeout(() => {
          this.style.display = "none";
        }, 310);
      }, 10);
    }
  }
}
customElements.define("wi-cartdrawer", WIcartDrawer);

class WIcartDrawerInfo extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.incQuantity.bind(this));
    this.addEventListener("click", this.decQuantity.bind(this));
    this.addEventListener("click", this.revQuantity.bind(this));
  }
  connectedCallback() {
    this.quickAddUpdate();
    this.defaultATC();
    this.totalSaving();
    this.freeShipping();
  }

  async updateCart() {
    let res = await fetch("/?section_id=wi-cartdrawer");
    let text = await res.text();
    let html = document.createElement("div");
    html.innerHTML = text;
    let cartItems = html.querySelector(".WI_cartDrawerin_cart").innerHTML;
    document.querySelector(".WI_cartDrawerin_cart").innerHTML = cartItems;
    document.dispatchEvent(
      new CustomEvent("cartAllProcessEnded", { bubbles: true }),
    );
    this.totalSaving();
    this.freeShipping();
  }
  quickAddUpdate() {
    document.addEventListener("updateCart", () => {
      this.updateCart();
    });
  }
  async incQuantity(event) {
    if (event.target.matches(".WI_cartDrawer_plus")) {
      let rOOt = event.target;
      let keyID =
        rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute(
          "data-itemKey",
        );
      let quantity = Number(
        rOOt.parentElement.parentElement.querySelector("input").value,
      );
      let newQuantity = quantity + 1;
      this.querySelector(".WI_cartLoadingin").classList.add(
        "WI_cartLoadingActive",
      );
      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [keyID]: newQuantity,
          },
        }),
      });
      this.updateCart();
    }
  }
  async decQuantity(event) {
    if (event.target.matches(".WI_cartDrawer_minus")) {
      let rOOt = event.target;
      let keyID =
        rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute(
          "data-itemKey",
        );
      let quantity = Number(
        rOOt.parentElement.parentElement.querySelector("input").value,
      );
      let newQuantity = quantity - 1;
      rOOt.parentElement.parentElement.parentElement.parentElement.parentElement
        .querySelector(".WI_cartLoadingin")
        .classList.add("WI_cartLoadingActive");

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [keyID]: newQuantity,
          },
        }),
      });
      this.updateCart();
    }
  }
  async revQuantity(event) {
    if (event.target.matches(".cartDrawerRemove")) {
      let rOOt = event.target;
      let keyID =
        rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute(
          "data-itemKey",
        );
      let quantity = 0;
      console.log(keyID);
      rOOt.parentElement.parentElement.parentElement.parentElement.parentElement
        .querySelector(".WI_cartLoadingin")
        .classList.add("WI_cartLoadingActive");
      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: {
            [keyID]: quantity,
          },
        }),
      });
      this.updateCart();
    }
  }
  async freeShipping() {
    let freeShippingValue = Number(
      this.querySelector(".freeShippingValue").value,
    );
    let freeShippingPara = this.querySelector("#freeShippingTxt");
    let freeShippingProgressBar = this.querySelector(
      ".WI_freeShippingBar_progress",
    );
    let shippingRes = await fetch("/cart.js");
    let shippingData = await shippingRes.json();
    let cartPrice = shippingData.total_price / 100;
    console.log(cartPrice, freeShippingValue);
    if (cartPrice < freeShippingValue) {
      let shippingPriceDiffer = freeShippingValue - cartPrice;
      shippingPriceDiffer = (
        Math.round(shippingPriceDiffer * 100) / 100
      ).toFixed(2);
      freeShippingPara.innerHTML =
        "køb for <strong style='color:rgba(0,0,0,1);'>" +
        shippingPriceDiffer +
        " kr.</strong> mere, og få fri fragt";
      let shippingPercent = parseInt((cartPrice / freeShippingValue) * 100);
      freeShippingProgressBar.style.width = shippingPercent + "%";
    } else {
      freeShippingPara.innerHTML = "Tillykke! Du har opnået gratis fragt.";
      freeShippingProgressBar.style.width = "100%";
    }
  }
  async totalSaving() {
    let lineItem = document.querySelectorAll(".WI_cartDrawer_item");
    let totalSaving = 0;
    lineItem.forEach((item) => {
      let totalSavingData = item.getAttribute("data-savingPrice");
      totalSaving += Number(totalSavingData);
    });
    setTimeout(() => {
      console.log(totalSaving / 100);
      if (totalSaving > 0) {
        document.querySelector(".savingIndiactor").style.display = "flex";
        document.querySelector(".savedMoney").innerHTML =
          "-" +
          (totalSaving / 100).toLocaleString("da-DK", {
            style: "currency",
            currency: "DKK",
          });
      }
    }, 100);
  }
  defaultATC() {
    const allForm = document.querySelectorAll('form[action="/cart/add"]');
    allForm.forEach((elem) => {
      elem.addEventListener("submit", async (e) => {
        e.preventDefault();
        let loadingCartBlock = document.querySelector(
          ".WI_loadingCartItemBlock",
        );
        let emptyCart = document.querySelector(".WI_cartDrawerin_cart_empty");
        if (loadingCartBlock != null) {
          loadingCartBlock.style.display = "block";
        }
        if (emptyCart != null) {
          emptyCart.style.display = "none";
        }
        document.dispatchEvent(new CustomEvent("openCart", { bubbles: true }));
      });
    });
  }
}
customElements.define("wi-cartdrawer-info", WIcartDrawerInfo);
